import { render, staticRenderFns } from "./station-detail-setting.vue?vue&type=template&id=78fe83af&scoped=true&"
import script from "./station-detail-setting.vue?vue&type=script&lang=js&"
export * from "./station-detail-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe83af",
  null
  
)

export default component.exports